import React from "react";
import { Spring } from "react-spring";
import moment from "jalali-moment";
import {Translate} from "../../../../../config/Translate";

const VerticalProgress = ({ progress,start_date,status,end_time,status_id,children }) => {
    return (
        <div className="progress-holder">
            <div className="progress vertical">
                <div style={{ height:`${progress}%` }} className="progress-bar">
                </div>
            </div>
            {
                status_id !== 1 &&
                <div className="first-info">
                    <div className="date">{moment(start_date).locale('fa').format("MM/DD")}</div>
                    <p className="status-title">{Translate.firstStatus}</p>
                </div>
            }
            <div className="additional-info" style={{ top:`${progress-10}%` }}>
                <div className="date">{moment().locale('fa').format("MM/DD")}</div>
                <div className="mx-15">{children}</div>
                <strong className="status-title">{status}</strong>

            </div>
            {
                status_id !== 9 &&
                <div className="last-info">
                    {end_time}
                </div>
            }
        </div>
    );
};

export default VerticalProgress;